import React from "react";
import styled from "styled-components";

const FormInput = styled.input`
	width: 100%;
	font-size: 14px;
	padding: 14px 18px;
	border-radius: 10px;
	border: 1.5px solid #dce2f0;
	background: #ffffff;
	color: #0c1538;
	outline: none;
	transition: all 0.25s ease;

	&:focus {
		border-color: #2806f9;
		box-shadow: 0 0 0 3px rgba(40, 6, 249, 0.12);
	}

	&::placeholder {
		color: #94a0b8;
	}
`;

const Input = ({ type, placeholder, name, id }) => {
	return (
		<FormInput type={type} name={name} id={id} placeholder={placeholder} />
	);
};

export default Input;
